export const compareArrays = (arrayOne, arrayTwo) => {
  console.log('Llegan', arrayOne.length, arrayTwo.length);

  if (arrayOne.length !== arrayTwo.length) return false;

  let sonIguales = true;

  for (let i = 0; i < arrayOne.length; i += 1) {
    const element = arrayOne[i];
    const index = arrayTwo.indexOf(element);
    console.log('indice', element, index, index === -1);
    if (index === -1) {
      sonIguales = false;
      break;
    }
  }

  return sonIguales;
};
